<template>
    <router-view></router-view>
</template>
<script>
  import { SlideYUpTransition } from 'vue2-transitions'
  //import firebase from 'firebase'
  //const currentUser = firebase.auth().currentUser;

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false,
        //user: currentUser
      }
    }
  }
</script>
<style>
</style>
